<template>
  <div class="m-10 personal">
    <el-tabs type="border-card" v-model="checkTab" @tab-click="handleTabsClick">
      <el-tab-pane label="基础信息" name="base">
        <div class="base-info">
          <div class="info">
            <ul>
              <li v-for="(item, index) in baseInfo" :key="item.key">
                <span class="label">{{ item.label }}</span>
                <span class="value" v-show="!item.isEdit">{{ filterItem(item.key) }}</span>
                <el-date-picker
                  v-if="item.type === 'date' && item.isEdit"
                  v-model="editValue"
                  type="date"
                  v-show="item.isEdit"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-select v-else-if="item.type === 'select' && item.isEdit" v-model="editValue" placeholder="请选择">
                  <el-option
                    v-for="item in getListByKey(item.key)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  class="base-input"
                  v-else-if="item.type === 'input' && item.isEdit"
                  v-model="editValue"
                ></el-input>
                <i class="icon el-icon-check" v-if="item.isEdit" @click="saveBaseInfo"></i>
                <i class="icon el-icon-close" v-if="item.isEdit" @click="cancelSaveBaseInfo"></i>
                <i
                  class="icon el-icon-edit"
                  v-if="!item.disabled && !item.isEdit"
                  @click="editBaseInfo(item, index)"
                ></i>
              </li>
              <li>
                <span class="label">登录密码</span>
                <span class="value">*******</span>
                <i class="icon el-icon-edit" @click="dgVisible = true"></i>
              </li>
              <li>
                <span class="label">手机号</span>
                <span class="value">{{ user.telephone }}</span>
                <i class="icon el-icon-edit" @click="phoneVisible = true"></i>
              </li>
            </ul>
          </div>
          <div class="avt"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="所属部门" name="org">
        <el-table :data="tableDataOrg" v-loading="loading">
          <el-table-column prop="full_name" label="部门名称"></el-table-column>
          <el-table-column prop="code" label="部门代码"></el-table-column>
          <el-table-column prop="create_time" label="加入时间"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="所属角色" name="role">
        <el-table :data="tableDataRole" v-loading="loading">
          <el-table-column prop="role_name" label="角色名称"></el-table-column>
          <el-table-column prop="create_time" label="加入时间"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="项目信息" name="special">
        <el-table :data="tableDataSub" v-loading="loading">
          <el-table-column prop="specialized_subject_name" label="项目大类/项目名称"></el-table-column>
          <el-table-column prop="specialized_subject_code" label="项目代码"></el-table-column>
          <el-table-column prop="create_time" label="加入时间"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="打折理由" name="discount">
        <el-table :data="tableDataDis" v-loading="loading">
          <el-table-column prop="reason" label="折扣理由"></el-table-column>
          <el-table-column prop="rate" label="折扣率">
            <template slot-scope="{ row }">{{ row.rate | percent }}</template>
          </el-table-column>
          <el-table-column prop="create_time" label="加入时间"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="dgVisible" title="修改登录密码" width="450px" :show-close="!force">
      <ChangePwd ref="changePwd" />
      <div slot="footer">
        <el-button v-if="!force" @click.native="dgVisible = false">取消</el-button>
        <el-button type="primary" @click.native="savePassword">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="phoneVisible" title="设置手机号" width="600px">
      <ChangePhone ref="changePhone" v-if="phoneVisible" @closeWindow="closeWindow" />
    </el-dialog>
  </div>
</template>

<script>
import { DatePicker, Dialog, Input, Option, Select, Tabs, TabPane, Table, TableColumn } from 'element-ui';
import { sys } from '@/api';
import pattern from '@/utils/pattern';
import ChangePwd from '@/components/ChangePwd';
import ChangePhone from '@/components/ChangePhone';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'PersonalBase',
  components: {
    ChangePwd,
    ChangePhone,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElInput: Input,
    ElOption: Option,
    ElSelect: Select,
    ElDatePicker: DatePicker,
    ElDialog: Dialog
  },
  data() {
    return {
      checkTab: 'base',
      tableDataOrg: [],
      tableDataRole: [],
      tableDataSub: [],
      tableDataDis: [],
      loading: false,
      jobs: [],
      genders: [],
      editIndex: -1,
      editValue: '',
      baseInfo: [
        {
          label: '真实姓名',
          key: 'real_name',
          isEdit: false,
          disabled: true,
          type: 'input',
          rule: ''
        },
        {
          label: '身份证号',
          key: 'id_card_no',
          isEdit: false,
          type: 'input',
          disabled: true,
          rule: pattern.idCard
        },
        {
          label: '职务',
          key: 'job',
          isEdit: false,
          disabled: true,
          type: 'select',
          rule: ''
        },
        {
          label: '性别',
          key: 'gender',
          isEdit: false,
          type: 'select',
          rule: ''
        },
        {
          label: '出生日期',
          key: 'birthday',
          isEdit: false,
          type: 'date',
          rule: ''
        },
        {
          label: 'email',
          key: 'email',
          isEdit: false,
          type: 'input',
          rule: pattern.email
        },
        {
          label: '登录名',
          key: 'username',
          type: 'input',
          isEdit: false,
          rule: '',
          disabled: true
        }
      ],
      dgVisible: false,
      phoneVisible: false,
      force: false // 强制修改密码
    };
  },
  mounted() {
    this.init();
    this.passWordStatus();
  },
  updated() {
    this.passWordStatus();
  },
  filters: {
    percent(value) {
      return typeof value === 'number' ? `${Decimal.mul(value, 100).toNumber()} %` : '';
    }
  },
  computed: {
    user() {
      return this.$store.state.user.info;
    },
    getListByKey() {
      return key => this[`${key}s`];
    },
    filterItem() {
      return key => {
        const value = this.user[key];
        if (key === 'gender') {
          const temp = this.genders.filter(item => item.value === value);
          return temp.length ? temp[0].label : '';
        }
        if (key === 'job') {
          const temp = this.jobs.filter(item => item.value === value);
          return temp.length ? temp[0].label : '';
        }
        return value;
      };
    }
  },
  methods: {
    passWordStatus() {
      if (this.$route.query.is_need_update_password === 'true') {
        this.force = true;
        this.dgVisible = true;
      }
    },
    async init() {
      const awRes = sys.userJobChoose();
      const awGRes = sys.userGenderChoose();

      const jobRes = await awRes;
      const gRes = await awGRes;

      if (jobRes) this.jobs = jobRes.data;
      if (gRes) this.genders = gRes.data;
    },
    closeWindow() {
      this.phoneVisible = false;
    },
    editBaseInfo(item, index) {
      if (this.editIndex >= 0) {
        this.baseInfo[this.editIndex].isEdit = false;
      }
      this.editIndex = index;
      this.baseInfo[index].isEdit = true;
      this.editValue = this.user[item.key];
    },
    async saveBaseInfo() {
      const value = this.editValue;
      if (value) {
        const regex = this.baseInfo[this.editIndex].rule;
        if (regex && !regex.test(value)) {
          this.$message.warning('请填写正确的信息');
          return;
        }
      } else {
        this.$message.warning('请填写正确的信息');
        return;
      }
      const item = this.baseInfo[this.editIndex];
      item.isEdit = false;
      this.editIndex = -1;
      const res = await sys.controlUser({
        id: this.user.id,
        methold: 'put',
        params: {
          [item.key]: value
        }
      });
      if (res && res.data) {
        this.$message.success(res.msg);
        this.$store.dispatch('user/addUser', res.data.user);
      }
    },
    cancelSaveBaseInfo() {
      this.baseInfo[this.editIndex].isEdit = false;
      this.editIndex = -1;
      this.editValue = '';
    },
    async handleTabsClick({ name }) {
      this.loading = true;
      if (name === 'role' && !this.tableDataRole.length) {
        const res = await sys.userRoleList({ id: this.user.id });
        if (res && res.data) {
          this.tableDataRole = Object.freeze(res.data.list);
        }
      } else if (name === 'special' && !this.tableDataSub.length) {
        const res = await sys.userRoleSubList({ id: this.user.id });
        if (res && res.data) {
          this.tableDataSub = Object.freeze(res.data.list);
        }
      } else if (name === 'org' && !this.tableDataOrg.length) {
        const res = await sys.userOrgList({ id: this.user.id });
        if (res && res.data) {
          // 中国儿童中心
          this.tableDataOrg = Object.freeze(res.data.list);
        }
      } else if (name === 'discount' && !this.tableDataDis.length) {
        const res = await sys.perisonDisCounts({ id: this.user.id });
        if (res && res.data) {
          this.tableDataDis = Object.freeze(res.data.list);
        }
      }
      this.loading = false;
    },
    async savePassword() {
      const { data, valid } = await this.$refs.changePwd.submitForm();
      if (valid) {
        const res = await sys.changePassword({
          params: {
            re_new_password: data.checkPass,
            new_password: data.new_password,
            old_password: data.old_password
          }
        });
        if (res) {
          this.dgVisible = false;
          this.$message.success('修改成功，请重新登录！');
          this.$store.dispatch('user/logout');
        }
      }
    }
  }
};
</script>

<style lang="less">
.personal {
  .base-info {
    .info {
      ul {
        padding-left: 0;
        li {
          list-style: none;
          padding: 10px 0;
          .base-input {
            width: 300px;
          }
          .label {
            display: inline-block;
            min-width: 120px;
            font-weight: 700;
            text-align: right;
            padding-right: 30px;
          }
          .icon {
            margin-left: 20px;
            cursor: pointer;
            display: none;
            &:hover {
              color: @main-blue;
            }
          }
          &:hover .icon {
            display: initial;
          }
        }
      }
    }
  }
  .account {
    .label {
      display: inline-block;
      width: 100px;
    }
    .value {
      display: inline-block;
      min-width: 120px;
    }
  }
}
</style>
